import { styled, Typography, IconButton } from '@material-ui/core'

export const CLOSE_BTN_OFFSET = 15
export const CLOSE_BTN_SIZE = 28
const CONTAINER_WIDTH = 550
const CONTAINER_HEIGHT = 480
const DIALOG_TEXT_WIDTH = 330
const DIALOG_TITLE_FONT_SIZE = 24
const DIALOG_TEXT_FONT_SIZE = 14

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: CONTAINER_WIDTH,
  height: CONTAINER_HEIGHT,
  padding: theme.spacing(4),
}))

export const DialogContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '100%',
})

export const ButtonGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  marginTop: theme.spacing(3),
  '& .MuiButtonBase-root': {
    padding: theme.spacing(0.6, 2.7),
    marginRight: theme.spacing(),
    fontWeight: 600,
  },
}))

export const DialogTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: DIALOG_TITLE_FONT_SIZE,
})

export const DialogText = styled('div')({
  width: DIALOG_TEXT_WIDTH,
  '& .MuiTypography-root': {
    // fontWeight: 300,
    fontSize: DIALOG_TEXT_FONT_SIZE,
    textAlign: 'center',
  },
})

export const Image = styled('img')({
  height: '70%',
  width: '70%',
})

export const CloseButton = styled(IconButton)({
  position: 'absolute',
  '& svg': {
    width: CLOSE_BTN_SIZE,
    height: CLOSE_BTN_SIZE,
  },
  right: CLOSE_BTN_OFFSET,
  top: CLOSE_BTN_OFFSET,
})
